import { TablePaginationProps } from "@mui/material";
import { MaterialReactTableProps } from "material-react-table";

export const RowsPerPageOptions: TablePaginationProps["rowsPerPageOptions"] = [
  5, 10, 25, 50, 100, 200, 300,
];

export const MaterialReactTableOptionsDefault: Partial<MaterialReactTableProps> =
  {
    enablePinning: true,
    enableDensityToggle: false,
    enableRowNumbers: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnResizing: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        muiTableHeadCellProps: { align: "center" },
      },
    },
    muiTableContainerProps: { sx: { maxHeight: 500 } },
    muiTablePaperProps: {
      elevation: 0,
    },
    muiTablePaginationProps: {
      rowsPerPageOptions: RowsPerPageOptions,
      showFirstButton: true,
      showLastButton: true,
    },
  } as const;
